import { Button, Modal, Alert } from 'react-bootstrap';
import React from "react";
import { Field, reduxForm } from 'redux-form';
import 'react-widgets/dist/css/react-widgets.css';

import { SimpleField, ReadonlyInput, WideField, TextAreaField } from '../common/Inputs';
import { FileInput } from '../common/FileInput';

import * as fetchingState from '../../constants/fetchingState';
import * as errorCode from '../../constants/errorCode';

const errMap = {
    [errorCode.NOT_FOUND]: 'Категория не найдена',
    [errorCode.CATEGORY_NOT_EMPTY]: errorCode.getErrorMessage(errorCode.CATEGORY_NOT_EMPTY),
    [errorCode.INTERNAL_ERROR]: 'Внутренняя ошибка',
};

let Edit = class extends React.Component {
    constructor(props) {
        super(props);
        this._handleSubmit = this._handleSubmit.bind(this);
    }

    _handleSubmit(values) {
        this.props.onSubmit(values);
    }

    render() {
        const { fetching, initialValues: category, onClose, handleSubmit, isNew, crudError } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;
        let errorStr = errMap[crudError] ? errMap[crudError] : crudError;
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новая категория' : 'Редактирование категории'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)}>
                        {!isNew && <ReadonlyInput value={category.Id} label="Id" />}
                        <Field name="Name" component={SimpleField} label='Название' />
                        <Field name="Title" component={SimpleField} label="Заголовок" />
                        <Field name="Description" component={TextAreaField} label='Описание' />
                        <Field name="Keywords" component={TextAreaField} label='Ключевые слова' />
                        <Field name="IsActive" component={WideField} label='Активна' type='checkbox' />
                        <Field name="Image" component={FileInput} label='Иконка' />
                        <Field name="SeoTitle" component={SimpleField} label="Seo Заголовок" />
                        <Field name="SeoDescription" component={TextAreaField} label='Seo Описание' />
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                            {errorStr && <p>{errorStr}</p>}
                        </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

Edit = reduxForm({
    form: 'categoryEdit'
})(Edit);

export default Edit;


// WEBPACK FOOTER //
// ./src/components/services/CategoryEditModal.jsx